import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin.js'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(ScrollTrigger)

/**
 * TextImage component.
 * @author Dayne Coulson-Hoffacker
 */
export default class TextImage {
  /**
   * Constructs a new TextImage section.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor(options) {
    this.element = options.element
    this.globalDuration = options.globalDuration
    this.textColumn = this.element.querySelector('.column.text .inner')
    this.imageColumn = this.element.querySelector('.image')
    this.imageEl = this.element.querySelector('.column.image picture')
    this.video = this.element.querySelector('video')

    if (this.element.classList.contains('welcome')) {
      this.arrowSVGEl = this.element.querySelector('[data-component="arrow-animation-svg"]')
      this.arrowSVG = this.arrowSVGEl.querySelector('path')
      this.starSVGEl = this.element.querySelector('[data-component="star-animation-svg"]')
      this.homeAnimationEl = this.element.querySelector('[data-component="home-hero-animation-svg"]')
      this.leftEye = this.element.querySelector('g#left_eye path')
      this.rightEye = this.element.querySelector('g#right_eye path')

      const welcomeTL = gsap.timeline({ paused: true, onComplete: this.playVideo() })
      welcomeTL.to(this.imageColumn, { duration: 0.5, autoAlpha: 1, opactity: 1, visibility: 'visible' }, '.5')
      this.smile = this.element.querySelector('g#smile path')

      welcomeTL.to(this.textColumn, { duration: 1, autoAlpha: 1, ease: 'power2' })
      welcomeTL.to(this.imageColumn, { duration: 0.5, autoAlpha: 1, opactity: 1, visibility: 'visible' }, '.5')
      welcomeTL.to(this.imageEl, { duration: 0.5, autoAlpha: 1, scale: 1 }, '<')
      welcomeTL.to(this.arrowSVGEl, { autoAlpha: 1 })
      welcomeTL.from(this.arrowSVG, { duration: 2, drawSVG: '50% 50%', ease: 'power4.out' }, '<')
      welcomeTL.fromTo(this.starSVGEl, 1, { visibility: 'visible', opacity: 1, transform: 'scale(0)', transformOrigin: 'center right' }, { transform: 'scale(1)' }, '<')
      welcomeTL.to(this.homeAnimationEl, { visibility: 'visible', opacity: 1 }, '<')
      welcomeTL.from(this.leftEye, { duration: 1, drawSVG: '100% 100%', ease: 'power4.out' }, '<')
      welcomeTL.from(this.rightEye, { duration: 1, drawSVG: '100% 100%', ease: 'power4.out' }, '<')
      welcomeTL.from(this.smile, { duration: 1, drawSVG: '100% 100%', ease: 'power4.out' }, '<')

      ScrollTrigger.create({
        trigger: this.element,
        start: 'top 40%',
        markers: false,
        scroller: 'body',
        onEnter: () => {
          welcomeTL.play()
        }
      })
    } else {
      const imageTextTL = gsap.timeline({ paused: true, onComplete: this.playVideo() })
      imageTextTL.to(this.textColumn, { duration: 1, autoAlpha: 1, ease: 'power2' })
      imageTextTL.to(this.imageColumn, { duration: 0.5, autoAlpha: 1, opactity: 1, visibility: 'visible' }, '.5')
      imageTextTL.to(this.imageEl, { duration: 0.5, autoAlpha: 1, scale: 1 }, '<')

      ScrollTrigger.create({
        trigger: this.element,
        start: 'top 40%',
        markers: false,
        scroller: 'body',
        onEnter: () => {
          imageTextTL.play()
        }
      })
    }
  }

  playVideo () {
    if(this.video){
      this.video.play()
    }
  }
}



// WEBPACK FOOTER //
// ./components/section/text-image/index.js